"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = renderToLayer;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

/**
 * Монтирует дерево оборачиваемого `Target` в отдельную ноду в DOM.
 *
 *  @renderToLayer
 *  class Popup extends Component {
 *
 *    render() {
 *      const {
 *        isOpened,
 *        children,
 *        ...other
 *      } = this.props
 *
 *      return (
 *        <div {...other} style={{ display: isOpened ? 'block' : 'none' }}>
 *          {children}
 *        </div>
 *      )
 *    }
 *
 *  }
 *
 * Передает в оборачиваемый компонент следующие props:
 * - isOpened - контролирует видимость контента
 * - onOpen() - коллбек, который нужно вызвать в `Target` после открытия, например после окончания всех анимаций
 * - onClose() - коллбек, который нужно вызвать в `Target` после закрытия, например после окончания всех анимаций
 */
function renderToLayer(Target) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(RenderToLayer, _Component);

    var _super = _createSuper(RenderToLayer);

    function RenderToLayer() {
      var _this;

      (0, _classCallCheck2.default)(this, RenderToLayer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.state = {
        isOpened: _this.props.isOpened || false
      };

      _this.onOpen = function () {
        _this.props.onOpen();
      };

      _this.onClose = function () {
        _this.props.onClose();

        _this.unmountPortal();
      };

      return _this;
    }

    (0, _createClass2.default)(RenderToLayer, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.isOpened) this.mountPortal();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var isOpened = this.props.isOpened;
        if (isOpened !== prevProps.isOpened) if (isOpened) this.mountPortal();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.unmountPortal();
      }
    }, {
      key: "getContentContainerNode",
      value: function getContentContainerNode() {
        if (!this.node) {
          this.node = document.createElement('div');
          this.node.style.position = 'absolute';
          this.node.style.zIndex = this.props.zIndex;
          this.props.containerRef(this.node);
          document.body.appendChild(this.node);
        }

        return this.node;
      }
    }, {
      key: "mountPortal",
      value: function mountPortal() {
        this.setState({
          isOpened: true
        });
      }
    }, {
      key: "unmountPortal",
      value: function unmountPortal() {
        if (this.node) {
          this.props.containerRef();
          this.setState({
            isOpened: false
          });
          document.body.removeChild(this.node);
          this.node = null;
        }
      }
    }, {
      key: "renderContent",
      value: function renderContent() {
        return _react.default.createElement(Target, (0, _extends2.default)({}, this.props, {
          onOpen: this.onOpen,
          onClose: this.onClose
        }));
      }
    }, {
      key: "render",
      value: function render() {
        if (!this.state.isOpened) return null;
        return (0, _reactDom.createPortal)(this.renderContent(), this.getContentContainerNode());
      }
    }]);
    return RenderToLayer;
  }(_react.Component), _class.propTypes = {
    /**
     * Контролирует видимость
     */
    isOpened: _propTypes.default.bool,

    /**
     * Значение z-index
     */
    zIndex: _propTypes.default.number,

    /**
     * Коллбек вызывающийся после открытия
     */
    onOpen: _propTypes.default.func,

    /**
     * Коллбек вызывающийся после закрытия
     */
    onClose: _propTypes.default.func,

    /**
     * Коллбек вызывающийся при монтировании/размонтировании контейнера
     */
    containerRef: _propTypes.default.func
  }, _class.defaultProps = {
    isOpened: false,
    onOpen: function onOpen() {},
    onClose: function onClose() {},
    containerRef: function containerRef() {}
  }, _temp;
}